// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_3cb6d34","text":"_8cdd3ba","takeSeatButton":"_1bd9464"};